<template>
  <div>
  <b-breadcrumb style="margin-bottom:20px">
    <b-breadcrumb-item to="/">
        <feather-icon icon="HomeIcon" size="16" class="align-text-top" />
      </b-breadcrumb-item>
    <b-breadcrumb-item :to="'/counter/view/' + $route.query.counterID"  v-if="$route.query.counterID"
      >Kiosk PO List</b-breadcrumb-item
    >
    <b-breadcrumb-item to="/kiosk-po" v-else
      >Kiosk PO List</b-breadcrumb-item
    >
    <b-breadcrumb-item active>Add Kiosk PO</b-breadcrumb-item>
  </b-breadcrumb>
  <b-card title="Create Kiosk PO">
    <b-modal v-model="disableButton" centered no-close-on-backdrop hide-footer hide-header>
      <div class="d-flex flex-column align-items-center justify-content-center py-3">
        <b-spinner medium variant="primary" label="Spinning"></b-spinner>
        <p class="mt-3">Processing Purchase Order</p>
      </div>
    </b-modal>
    
    <!-- Stock Check Loading Modal -->
    <b-modal v-model="checkingStock" centered no-close-on-backdrop hide-footer hide-header>
      <div class="d-flex flex-column align-items-center justify-content-center py-3">
        <b-spinner medium variant="primary" label="Spinning"></b-spinner>
        <p class="mt-3">Checking Stock Availability</p>
      </div>
    </b-modal>

    <!-- Item List Loading Modal -->
    <b-modal v-model="loadingItems" centered no-close-on-backdrop hide-footer hide-header>
      <div class="d-flex flex-column align-items-center justify-content-center py-3">
        <b-spinner medium variant="primary" label="Spinning"></b-spinner>
        <p class="mt-3">Loading item list</p>
      </div>
    </b-modal>
    
    <!-- Stock Error Modal -->
    <b-modal v-model="showStockErrorModal" title="Stock Check Errors" ok-only>
      <b-list-group>
        <b-list-group-item v-for="(error, index) in stockErrorArray" :key="index" variant="danger">
          <strong>{{ error.itemModel }}:</strong> {{ error.message }}
        </b-list-group-item>
      </b-list-group>
    </b-modal>

    <!-- Image Item Modal -->
    <b-modal
      id="image-modal"
      v-model="modalImage"
      title="Preview Image"
      hide-footer
      size="lg"
      centered
    >
      <div class="text-center">
        <img
          :src="selectedImage"
          alt="Image preview"
          style="max-width: 100%; max-height: 500px"
        />
      </div>
    </b-modal>
    
    <b-col cols="12">

      <b-row>
        <b-col cols="12">
          <b-form @submit.prevent="">
            <div class="mb-2">
              <b-button
              @click="goBack"
              type="button"
              variant="primary"
              class="mr-1"
              :disable="disableButton"
              >Back To Kiosk PO List</b-button
            >
            </div>
            <br>
            <!--temporary hardcode only show this form select when current dealer not found-->
            
            <b-row>
              <b-col cols="12" md="6" v-if="!getCounterID && !getDealer">
                <b-form-group >
                  <span>Dealer <span style="color:red">(*)</span></span>
                  <v-select
                    v-model="dealerChoice"
                    placeholder="----- Select Dealer -----"
                    :options="dealer"
                    label="dealerName"
                    @input="defineDealer"
                    :clearable="false"
                    style="margin-top:5px !important;"
                    class="mb-1"
                  />
                  <strong v-if="!dealerChoice" style="color:red;">Please Select Dealer first</strong>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-row
              v-if="dealerChoice && !getCounterID"
              style="margin-bottom:10px !important; margin-left:5px !important;"
            >
              <b-col cols="6">
                <b-row> Dealer Name : {{ dealerChoice.dealerName }}</b-row>
                <b-row> Industry Type : {{ dealerChoice.industryType }}</b-row>
                <b-row> Second Industry Type : {{ dealerChoice.secondIndustryType }}</b-row>
              </b-col>
              <b-col cols="2">
                <b-button variant="danger" size="sm" @click="emptyDealer"
                  >X</b-button
                >
              </b-col>
            </b-row>
            <!-- if this process is counter-->
            <b-form-group v-if="getCounterID" label="Assign Discount to All Items">
              <b-row align-v="center">
                <b-col cols="12" sm="4" lg="3">
                  <b-input-group>
                    <b-form-input
                      v-model="currentDiscount"
                      type="number"
                      min="0"
                      :max="maxDiscountValue"
                      placeholder="Enter discount"
                      class="text-right"
                      @keydown.enter.prevent
                    ></b-form-input>
                    <b-input-group-append is-text>%</b-input-group-append>
                    <b-input-group-append>
                      <b-button variant="primary" @click="applyDiscountToAllItems">Apply</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col cols="12" sm="8" lg="9" class="mt-2 mt-sm-0">
                  <ul class="list-unstyled mb-0">
                    <li><small class="text-muted">Maximum discount: {{ maxDiscountValue }}%</small></li>
                    <li><small class="text-muted">Highest item discount: {{ highestDiscount }}%</small></li>
                  </ul>
                </b-col>
              </b-row>
            </b-form-group>
            
            <!--section displays to order item-->
            <div class="cart__area" style="margin-top:10px !important;">
              <div class="card__area-body">
                <div :class="getCounterID ? 'cart__area-columns-with-discount mb-1' : 'cart__area-columns mb-1'">
                  <span>Item<span style="color:red">(*)</span> </span>
                  <span v-if="!getCounterID"></span>
                  <span>
                    Quantity
                  </span>
                  <span>
                    Unit Price
                  </span>
                  <span v-if="getCounterID">
                    Discount
                  </span>
                  <span v-if="getCounterID">
                    Discount Amount
                  </span>
                  <span>
                    Total Price
                  </span>
                  <span> </span>
                </div>

                <div
                  :class="getCounterID ? 'cart__area-columns-with-discount' : 'cart__area-columns'"
                  :key="index"
                  v-for="(cartItem, index) in form.items"
                >
                  <v-select
                    :disabled="!industryTypeValid"
                    class="style-chooser"
                    @input="(selected) => fillItemInfoForm(index, selected, cartItem)"
                    v-model="cartItem.itemModel"
                    @search="onItemSearch"
                    :options="searchItems"
                    :filterable="false"
                    :clearSearchOnSelect="true"
                  >
                    <template #option="{ description,itemModel }">
                      {{ itemModel }}
                      <br />
                      <cite style="font-size:8px">{{ description }}</cite>
                    </template>
                    <template
                      #selected-option="{ option }"
                      :slot-scope="option"
                      style="font-size:10px"
                    >
                      <cite style="font-size:10px">{{
                        `${cartItem.itemModel} - ${cartItem.description}`
                      }}</cite>
                    </template>
                  </v-select>
                  <b-button
                    variant="warning"
                     v-if="!getCounterID"
                    @click="openImageModal(cartItem.itemModel)"
                    :disabled="!cartItem.itemModel || disableButtonImage"
                  >
                    Show Image
                  </b-button>
                  <b-form-input
                    v-model="cartItem.qty"
                    type="number"
                    placeholder="Enter Qty"
                    @input="(payload) => changeItemInfoQty(index, cartItem)"
                    @keydown.enter.prevent
                  ></b-form-input>

                  <!-- Kolom Unit Price -->
                  <b-form-input
                    :value="formatter(cartItem.price)"
                    type="number"
                    style="text-align: right;"
                    placeholder="Enter Price"
                    disabled
                  ></b-form-input>

                  <!-- Kolom Unit Discount -->
                  <b-input-group v-if="getCounterID">
                    <b-form-input
                      v-model="cartItem.unitDiscount"
                      :value="formatter(cartItem.unitDiscount)"
                      @input="changeItemInfoDiscount(index, cartItem)"
                      :max="maxDiscountValue"
                      style="text-align: right;"
                    />
                    <b-input-group-append is-text>%</b-input-group-append>
                  </b-input-group>

                  <!-- Kolom Unit Discount Amount -->
                  <b-input-group v-if="getCounterID">
                    <b-form-input
                      :value="getDiscountAmountDisplay(cartItem, index)"
                      @input="onDiscountAmountInput(index, cartItem, $event)"
                      @focus="startEditingDiscountAmount(index, cartItem)"
                      @blur="finishEditingDiscountAmount(index, cartItem)"
                      type="number"
                      step="0.01"
                      style="text-align: right;"
                    />
                  </b-input-group>

                  <b-form-input
                    type="number"
                    :value="formatter(cartItem.totalPrice)"
                    placeholder="Total Price"
                    style="text-align: right;"
                    disabled
                  ></b-form-input>

                  <b-button
                    variant="danger"
                    @click="cartRemoveItem(index)"
                    :disabled="!industryTypeValid"
                  >
                    <b-icon-trash />
                  </b-button>
                </div>

                <!-- ======================================================= -->
                <div class="cart__area_mobile">
                  <div class="card__area-body_mobile">
                    <div class="cart__area-columns_mobile mb-1_mobile">
                      <b-row
                        :key="index"
                        v-for="(cartItem, index) in form.items"
                      >
                        <b-col cols="12">
                          <b-row style="margin-bottom:10px">
                            <b-col cols="12">
                              <b-form-group label="Item">
                                <span style="color:red">(*)</span>
                              </b-form-group>
                              <v-select
                                :disabled="!industryTypeValid"
                                :hint="
                                  `${cartItem.itemModel} - ${cartItem.description}`
                                "
                                style="font-size:10px"
                                @input="(selected) => fillItemInfoForm(index, selected, cartItem)"
                                v-model="cartItem.itemModel"
                                @search="onItemSearch"
                                :options="searchItems"
                                :filterable="false"
                              >
                                <template
                                  #selected-option="{ option }"
                                  :slot-scope="option"
                                  >{{
                                    `${cartItem.itemModel} - ${cartItem.description}`
                                  }}</template
                                >
                              </v-select>
                            </b-col>
                          </b-row>
                          <b-row style="margin-top:10px">
                            <b-col cols="3">
                              <b-form-input
                                v-model="cartItem.qty"
                                type="text"
                                placeholder="Enter Qty"
                                @input="
                                  (payload) =>
                                    changeItemInfoQty(index, cartItem)
                                "
                                @keydown.enter.prevent
                              ></b-form-input>
                            </b-col>
                            <b-col cols="3">
                              <b-form-input
                                :value="formatter(cartItem.price)"
                                type="text"
                                placeholder="Enter Price"
                                disabled
                              ></b-form-input>
                            </b-col>
                            <b-col cols="3">
                              <b-form-input
                                type="text"
                                :value="formatter(cartItem.totalPrice)"
                                placeholder="Total Price"
                                disabled
                              ></b-form-input>
                            </b-col>
                            <b-col cols="3">
                              <b-button
                                @click="cartRemoveItem(index)"
                                variant="danger"
                                :disabled="!industryTypeValid"
                              >
                                <b-icon-trash />
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </div>

                    <!-- =================================================== -->

                    <div class="cart__area-info mt-3">
                      <div class="cart__area-line-info">
                        <span>
                          Subtotal after discount
                        </span>

                        <b-form-input
                          :value="formatter(cartTotalPrice)"
                          placeholder="Total Price"
                          disabled
                          style="text-align: right;"
                        ></b-form-input>
                      </div>

                      <div class="cart__area-line-info">
                        <span>
                          GST {{ currentGST.value }}%
                        </span>

                        <b-form-input
                          :value="formatter(gstTotal)"
                          placeholder="GST"
                          disabled
                          style="text-align: right;"
                        ></b-form-input>
                      </div>

                      <div class="cart__area-line-info">
                        <span>
                          Total Price
                        </span>

                        <b-form-input
                          :value="formatter(cartTotal)"
                          placeholder="Cart Total"
                          disabled
                          style="text-align: right;"
                        ></b-form-input>
                      </div>
                    </div>

                    <!--section displays a check stock error-->
                    <div
                      ref="errorPage"
                      tabindex="-1"
                      id="stock-error"
                      class="alert alert-danger py-1"
                      v-if="stockError.length > 0"
                    >
                      <ul>
                        <li
                          v-for="(error, index) in Object.values(stockError)"
                          :key="index"
                        >
                          {{ error }}
                        </li>
                      </ul>
                    </div>
                    <!--END section displays a check stock error-->

                    <b-button
                      @click="cartAddItem"
                      class="my-2"
                      variant="outline-success"
                      :disabled="!industryTypeValid"
                    >
                      Add Item
                    </b-button>
                    <!--END choose item bundle from modal pop-up-->
                  </div>
                </div>
              </div>
            </div>
            <!--END section displays to order item-->

            <div>
              <b-form-group v-if="form.deliveryType !== 'SOWH'|| form.addressType!='Default Address'">
              
                <span
                  >Name
                  <span v-if="mandatoryStatus" style="color:red"
                    >(*)</span
                  ></span
                >
                <b-form-input
                  maxlength="40"
                  v-model="form.customer.firstName"
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="Enter Name"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span>Phone</span>
                <b-form-input
                  v-model="form.customer.phone"
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="Enter Phone"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span>Email</span>
                <b-form-input
                  v-model="form.customer.email"
                  style="margin-top:5px !important;"
                  type="email"
                  placeholder="Enter Email"
                ></b-form-input>
              </b-form-group>

              <!-- Insert customer po only if created by Dealer-->
              <b-form-group v-if="!getCounterID">
                <span>Customer PO</span>
                <b-form-input
                  v-model="form.customerPO"
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="Enter Customer PO"
                  @input="validateInput"
                ></b-form-input>
              </b-form-group>

              <b-form-group v-if="getCounterID">
                <span
                  >Payment Type
                  <span v-if="mandatoryStatus" style="color:red"
                    >(*)</span
                  ></span
                >
                <b-form-select
                  v-model="form.paymentType"
                  :options="counterPaymentSelectOptions"
                >
                </b-form-select>
              </b-form-group>

              <b-form-group>
                <span>Remarks<span style="color:red"> Can input up to 155 characters</span></span>
                <b-form-textarea
                v-model="form.remarks"
                style="margin-top:5px !important;"
                placeholder="Remarks"
                rows="4"
                max-rows="10"
                @input.native="remarksMaxHandler"
                ></b-form-textarea>
              </b-form-group>

            </div>

            <b-button
              @click="addSaleBtn"
              type="button"
              variant="success"
              class="mr-1"
              :disable="disableButton"
              >Confirm Order</b-button
            >
          </b-form>
        </b-col>
      </b-row>
    </b-col>
  </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "@/axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import lodash from "lodash";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { sleep } from "@/utils/utils.js";
// import { isRaw } from "@vue/composition-api";

export default {
  components: {
    "date-picker": DatePicker,
    "v-select": vSelect,
  },
  data() {
    return {
      //form to save data
      paymentOption: [
        { value: 'CASH', text: 'Paynow' },
        { value: 'NETS', text: 'Nets' },
        { value: 'MC', text: 'Credit Card Master Card' },
        { value: 'VISA', text: 'Credit Card Visa' },
        { value: 'LTER', text: 'Pay Later' }
      ],
      form: {
        deliveryType: "SOSC", //default form will be self collect
        customer: {
          type: "Individual",
          companyName: "",
          firstName: "",
          lastName: "",
          address: "",
          address2: "",
          address3: "",
          buildingName: "",
          phone: "",
          email: "",
          postal: "",
          city: "Singapore",
          //detail address
          street: "",
          block: "",
          floor: "",
          number: "",
          //detail address
        },
        items: [{ itemModel: "", description: "",qty:1, price:0, totalPrice:0, discountAmount:0, unitDiscount:0, availableQty:1 }],
        deliveryDate: "",
        orderType: "SELF_COLLECT_AMK", //default form will be self collect
        //save total
        subTotal: 0,
        tax: 0,
        totalPrice: 0,
        //end save total
        timeslot: null,
        paymentType: "CASH",
        addressType: "",
        priority: "",
        distChan:"",
        deliveryCity: "",
        deliveryPostal: "",
        deliveryPhone: "",
        deliveryEmail: "",
        deliveryAddress: "",
        deliveryAddress2: "",
        deliveryAddress3: "",
        deliveryInstruction: "",
        dealer: "",
        customerPO : "",
        remarks:"",
        fromType:"",
        counterID:"",
        approvalToken:"",
        missedQueueNumber:""
      },
      //discount assign handler
      currentDiscount: 0,
      highestDiscount: 0,
      selectedIndustryType:"SP",
      industryTypeOption:['D1','D2','D3', 'NR'],
      industryTypeValid:false,
      // mandatory for Address Type "Default Address"
      mandatoryStatus: true,

      // state for Delivery Block No and Delivery Unit No fields appear or not
      doBlockandUnitFieldsState: false,

      //end of form to save data
      stockError: {},
      item: null,
      itemQty: 0,
      // warehouses: [],
      promptDraft: false,
      orderTypes: [
        { value: "DELIVERY", text: "Delivery" },
      ],
      deliveryTypeOptions: [
        { value: "SOEC", text: "End Customer" },
        { value: "SOWH", text: "Internal Warehouse Delivery" },
      ],
      addBy: "item",
      addItemByOptions: [
        { value: "item", text: "Item" },
        { value: "bundle", text: "Bundle" },
        { value: "category", text: "Category" },
      ],
      optionAddress: ["Default Address", "New Delivery Address"],
      categoriesOptions: [],
      category: null,
      categoryItems: [],
      categoryItem: null,
      timestate: null,
      today: 0,
      deliveryDate: "",
      showBundleModal: false,
      modalImage: false,
      selectedImage: '',
      disableButtonImage:false,
      selectedBundle: null,
      bundleQuantity:1,
      publishedItems: [],
      timeslotOptions: [],
      timeslotTemplate:[
        "10 AM to 12 noon",
        "2 PM to 5 PM",
        "6 PM onwards",
      ],
      searchItems: [],
      ajaxItem: null,
      arrayStreet: [],
      arrayBuildingName: [],
      dealerChoice: null, //This is if dealer doesn't detect at active user
      goTo : '',
      //button disable
      disableButton: false,
      computedItemsResult: [], // Added for item computations
      flagInputPrice: false,
      checkingStock: false, // Flag for stock checking modal
      loadingItems: false, // Flag for item list loading modal
      counterPayLaterAllowed: false,

      // Stock error modal properties
      showStockErrorModal: false,
      stockErrorArray: [],
      
      // Editing state for discount amounts - avoiding $set issues on items
      editingStates: {
        discountAmounts: {},        // { itemKey: { editing: true, tempValue: '10.50' } }
        discountAmountsReplacement: {}
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.computeItems();
      },
      deep: true
    }
  },
  created() {
    //get current dealer
    this.$store.dispatch("dealer/getCurrentDealer").then((x) => {
      var payload = {};
      if (this.getDealer) {
        //if user is dealer
        this.loadUserDealer();
      } else {
        //trigger get without dist channel
        if(this.getCounterID){
          this.getItemList({
            page:1,
            entry:25
          }); 
        }
      }
    });
    
    // Get all dealers for dropdown when counter ID is not provided
    this.$store.dispatch("dealer/getAllDealers");
  },
  mounted() {
    const previous = sessionStorage.getItem('previousRouteName');
    if (previous) {
      this.goTo = previous
    }
    
    // Get missedQueueNumber from query params if available
    if (this.$route.query.missedQueueNumber) {
      this.form.missedQueueNumber = this.$route.query.missedQueueNumber;
    }
    
    this.listBundles();
    this.getAllDiscount(); // Get discount settings

    let now = new Date();
    this.today = Number.parseInt(String(now.getDate()).padStart(2, "0"));

    //temporary get api customer from axios
    this.$store.dispatch("dealer/getAllDealers");
    this.$store.dispatch("dealer/getCurrentDealer"); 
    //temporary get current user
    this.$store.dispatch("auth/fetchUser");

    this.$store.dispatch("GST/getCurrentGST");
    this.form.priority = "03"
    this.form.orderType === "SELF_COLLECT_AMK"
    this.cleanOrderType();
    if (this.$route.query.counterID) {
      this.loadCounterPayLaterSetting();
    }
  },
  methods: {
    ...mapActions({
      getAddressByPostal: "mapAPI/getAddressByPostal",
      addKioskPo: "purchase/addKioskPo",
      savePurchaseDraft: "purchase/savePurchaseDraft",
      listBundles: "item/listItemBundle",
      getItem: "item/getItems",
      getDealerKioskItemToOrder: "item/getDealerKioskItemToOrder",
      checkStock: "sendSAP/checkStock",
      getAllDiscount: "discount/getDiscountForEkioskEdit"
    }),
    loadCounterPayLaterSetting() {
      const cid = this.$route.query.counterID;
      if (!cid) {
        return;
      }
      this.$store
        .dispatch("counter/getCounter", cid)
        .then((c) => {
          this.counterPayLaterAllowed = !!(c && c.enablePayLater);
          if (!this.counterPayLaterAllowed && this.form.paymentType === "LTER") {
            this.form.paymentType = "CASH";
          }
        })
        .catch(() => {
          this.counterPayLaterAllowed = false;
          if (this.form.paymentType === "LTER") {
            this.form.paymentType = "CASH";
          }
        });
    },
    remarksMaxHandler(){
      if(this.form.remarks.length>155){
        this.form.remarks = this.form.remarks.substring(0, 155);
      }
    },
    applyDiscountToAllItems() {
      // Only apply discount if getCounterID is true
      if (!this.getCounterID) return;

      // Validate discount is within range
      if (this.currentDiscount < 0) {
        this.currentDiscount = 0;
      } else if (this.currentDiscount > this.maxDiscountValue) {
        this.currentDiscount = this.maxDiscountValue;
      }
      
      // Apply discount to all eligible items
      this.form.items.forEach((item) => {
        if (item.availableQty !== 0) {
          item.unitDiscount = parseFloat(this.currentDiscount);
          // Recalculate total price
          item.totalPrice = (item.price - (item.price * (item.unitDiscount / 100))) * item.qty;
          item.discountAmount = this.formatter(parseFloat(item.price * (item.unitDiscount / 100) * item.qty));
        }
      });
      
      if (parseFloat(this.currentDiscount) > this.highestDiscount) {
        this.highestDiscount = parseFloat(this.currentDiscount);
      }
      
      // Trigger recomputation
      this.computeItems();
    },
    getItemList(payload) {
      this.loadingItems = true;
      this.getDealerKioskItemToOrder(payload).then((data) => {
        this.searchItems = data
        .filter((distItem) => {
          const productHierarchy = distItem.item.productHierarchy;
          return (
            productHierarchy.startsWith("Z1000") ||
            productHierarchy.startsWith("A5100") ||
            productHierarchy.startsWith("U5100") ||
            productHierarchy.startsWith("U5300")
          );
        })
        .map((distItem) => {

          //handling item catalog only show at list when status = "" (Active)
          //NEW rule, show at list when price is above 0
          if (distItem.item.status === "") {
            //parse number decimal price
            distItem.price = parseFloat(distItem.price.$numberDecimal);
            //temporary use this for better price filter by distribution channel
            return {
              label: `${distItem.item.itemModel} - ${distItem.item.description}`,
              description: distItem.item.description,
              itemModel: distItem.item.itemModel,
              ...distItem,
            };
          }
        });
        this.industryTypeValid=true
      }).catch((err)=>{

        let { response } = err;

        console.error('error get dealer kiosk item to order',payload,this.searchItems)
        this.searchItems=[];
        this.industryTypeValid=false
        
        console.info('response ',response.data.errors[0].message)
        this.$bvToast.toast(response.data.errors[0].message, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
      }).finally(() => {
        this.loadingItems = false;
      });
    },
    defineDealer() {
      // Handle dealer selection for kiosk purchase - same flow as add-purchase.vue
      console.log("dealerChoice", this.dealerChoice);
      
      // Set industry type options
      this.industryTypeOption = [this.dealerChoice.industryType];
      if(this.dealerChoice.secondIndustryType != undefined && this.dealerChoice.secondIndustryType != ""){
        this.industryTypeOption.push(this.dealerChoice.secondIndustryType);
      }
      
      // Reset items array
      this.form.items = [{ itemModel: "", description: "", qty: 1, price: 0, totalPrice: 0, discountAmount: 0, unitDiscount: 0, availableQty: 1 }];
      
      // Set the selected industry type to the dealer's industry type
      this.selectedIndustryType = this.dealerChoice.industryType;
      
      // Get items based on the dealer's industry type
      this.getItemList({
        industryType: this.selectedIndustryType,
        entry:25,
        page:1,
      });
    },
    loadUserDealer(){
      //get dealer by user - implement same flow as add-purchase.vue
      this.industryTypeOption = [this.getDealer.industryType];
      if(this.getDealer.secondIndustryType != "" && this.getDealer.secondIndustryType != undefined){
        this.industryTypeOption.push(this.getDealer.secondIndustryType);
      }
      this.selectedIndustryType = this.getDealer.industryType;
      this.getItemList({
        industryType: this.selectedIndustryType,
        entry:25,
        page:1,
      });
    },
    formatter(value) {
      let number = value;
      if (typeof value === 'object' && value && value.$numberDecimal) {
        number = parseFloat(value.$numberDecimal);
      } else {
        number = parseFloat(value);
      }
      if (!isFinite(number)) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
    cleanUpDelivery() {
      if (
        this.form.orderType === "DELIVERY" &&
        this.form.deliveryType === "SOWH"
      ) {
        this.form.addressType = "Default Address";
        this.mandatoryStatus = false;
      } else {
        this.mandatoryStatus = true;
      }
      if (
        this.form.orderType === "DELIVERY" &&
        this.form.deliveryType === "SOEC"
      ) {
        this.form.customer = {
          type: "Individual",
          companyName: "",
          firstName: "",
          lastName: "",
          address: "",
          address2: "",
          address3: "",
          buildingName: "",
          phone: "",
          email : this.getDealer.dealerEmailAddress,
          postal: "",
          city: "Singapore",
          //detail address
          street: "",
          block: "",
          floor: "",
          number: "",
          //detail address
        };
      }
      if (
        this.form.deliveryType === "SOWH" &&
        this.form.addressType === "Default Address"
      ) {
        //console.log("this.getDealer_Default Address", this.getDealer);
        // this.form.customer.address = this.getDealer.billingAddress1.concat(" ", this.getDealer.billingAddress2);
        this.form.customer.email = this.getDealer.dealerEmailAddress;
        this.form.customer.postal = this.getDealer.postalCode;
        this.form.customer.phone = this.getDealer.phone;
        this.form.customer.firstName = this.getDealer.dealerName;
        this.form.customer.street = this.getDealer.billingAddress1;
        this.form.customer.buildingName = this.getDealer.billingAddress2;
      } else {
        this.form.customer = {
          type: "Individual",
          companyName: "",
          firstName: "",
          lastName: "",
          address: "",
          address2: "",
          address3: "",
          buildingName: "",
          phone: "",
          email : this.getDealer.dealerEmailAddress,
          postal: "",
          city: "Singapore",
          //detail address
          street: "",
          block: "",
          floor: "",
          number: "",
          //detail address
        };
      }
    },
    cleanOrderType() {
      /**
      AMK
      10 Ang Mo Kio Industrial Park 2, Singapore 569501

      SUMITOMO
      value=38 Tuas West Rd, Singapore 638385
      */
     
      //reset pickedTime & timeslot
      this.form.deliveryDate=""
      this.form.timeslot=""

      var dealerEmail = (this.getDealer&&this.getDealer!="")?this.getDealer.dealerEmailAddress:"";
      if (
        this.form.orderType === "SELF_COLLECT_AMK"
      ) {
        this.form.deliveryType = "SOSC";
        this.form.customer.address = "10 Ang Mo Kio Industrial Park 2";
        this.form.customer.email = dealerEmail;
        this.form.customer.postal = "569501";
        this.form.customer.phone = "";
        this.form.customer.firstName = "";
        this.form.customer.street = "10 Ang Mo Kio Industrial Park 2";
        this.form.customer.block = "";
        this.form.customer.buildingName = "";
        this.form.deliveryInstruction="Self Collect AMK";
        this.mandatoryStatus = true;
      } else if(
        this.form.orderType === "SELF_COLLECT_SUMITOMO")
      {
        this.form.deliveryType = "SOSC";
        this.form.customer.address = "38 Tuas West Rd";
        this.form.customer.email = dealerEmail;
        this.form.customer.postal = "638385";
        this.form.customer.phone = "";
        this.form.customer.firstName = "";
        this.form.customer.street = "38 Tuas West Rd";
        this.form.customer.block = "";
        this.form.customer.buildingName = "";
        this.form.deliveryInstruction="Self Collect Sumitomo";
        this.mandatoryStatus = true;

      } else {
        this.form.deliveryType = "SOEC";
        this.form.deliveryInstruction="";
        this.form.customer.email = (this.getDealer&&this.getDealer!="")?this.getDealer.dealerEmailAddress:"";
        this.cleanUpDelivery()
      }
    },
    autoFillDealer() {
      //ini buat load data waktu pilih warehouse dengan informasi detailnya
      if (
        this.form.deliveryType === "SOWH" &&
        this.form.addressType === "Default Address"
      ) {
        this.mandatoryStatus = false;
        this.form.customer.address = this.getDealer.billingAddress1.concat(
          " ",
          this.getDealer.billingAddress2
        );
        this.form.customer.email = this.getDealer.dealerEmailAddress;
        this.form.customer.postal = this.getDealer.postalCode;
        this.form.customer.phone = this.getDealer.phone;
        this.form.customer.firstName = this.getDealer.dealerName;
        this.form.customer.street = this.getDealer.billingAddress1;
        this.form.customer.buildingName = this.getDealer.billingAddress2;
      } else if (
        this.form.deliveryType === "SOWH" &&
        this.form.addressType === "New Delivery Address"
      ) {
        // this.form.customer.address =  this.form.customer.address ? this.form.customer.address : "";
        // this.form.customer.email =  this.form.customer.email ? this.form.customer.email : ""
        // this.form.customer.postal =  this.form.customer.postal ? this.form.customer.postal : ""
        // this.form.customer.phone =  this.form.customer.phone ? this.form.customer.phone : ""
        // this.form.customer.firstName = this.getDealer.dealerName
        this.form.customer.address = "";
        this.form.customer.email = "";
        this.form.customer.postal = "";
        this.form.customer.phone = "";
        this.form.customer.firstName = "";
        this.form.customer.street = "";
        this.form.customer.block = "";
        this.form.customer.buildingName = "";
        this.mandatoryStatus = true;
        
      } else {
        this.form.customer.address = this.form.customer.address
          ? this.form.customer.address
          : "";
        this.form.customer.email = this.form.customer.email
          ? this.form.customer.email
          : "";
        this.form.customer.postal = this.form.customer.postal
          ? this.form.customer.postal
          : "";
        this.form.customer.phone = this.form.customer.phone
          ? this.form.customer.phone
          : "";
        this.form.customer.firstName = this.form.customer.firstName
          ? this.form.customer.firstName
          : "";
        this.form.customer.lastName = this.form.customer.lastName
          ? this.form.customer.lastName
          : "";
        // this.mandatoryStatus = false;
        console.log("thiss", this.mandatoryStatus);
      }
      // console.log(this.form.customer)
    },
    //ini buat waktu ketik postal code kalo ada data yg tersimpan (di collection drccpostalinfos) buat auto load informasi lainnya
    autoFillAddress: lodash.debounce(function(a) {
      // console.log('this.itemDatabase', this.itemsDatabase)
      let arrayStreet = [];
      let arrayBuildingName = [];
      axios
        .get(`sales-and-purchase/drcc/postal-info`, {
          params: {
            postal: a,
          },
        })
        .then((response) => {
          let data = response.data.data;
          for (let postalData of data) {
            let { street, buildingName } = postalData;
            arrayStreet.push(street);
            arrayBuildingName.push(buildingName);
          }
          let newSetArrayStreet = [...new Set(arrayStreet)];
          let newSetArrayBuildingName = [...new Set(arrayBuildingName)];

          if (newSetArrayStreet.length > 1) {
            this.arrayStreet = newSetArrayStreet;
            this.isStreetArray = true;
          } else {
            this.form.customer.street = newSetArrayStreet[0];
            this.isStreetArray = false;
          }
          if (newSetArrayBuildingName.length > 1) {
            this.arrayBuildingName = newSetArrayBuildingName;
            this.isBuildingNameArray = true;
          } else {
            this.form.customer.buildingName = newSetArrayBuildingName[0];
            this.isBuildingNameArray = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }, 500),
    addItem() {
      //buat nambahin baris item list
      if (this.addBy === "bundle") {
        for (let i of this.item.items) {
          this.form.items.push({
            model: i.itemModel,
            qty: this.itemQty,
          });
        }

        return;
      }

      this.form.items.push({
        model: this.item,
        qty: this.itemQty,
      });
    },
    async addSaleBtn() {
      //ini waktu klik confirm purchase dimana akan kirim PO ke SAP. dengan sebelumnya akan check stock dulu per item
      //for handling dealer info

      var itemsToSAP = this.form.items.map(item => ({
        model: item.model,
        qty: item.qty
      }));

      //check stop api
      try {
        // Show the stock checking modal
        this.checkingStock = true;
        var checkStockApi = {}

        if(this.$route.query.counterID){
          checkStockApi = await this.checkStock({sloc:'01',items:itemsToSAP})
        }else{
          //if counterID is not present, set success to true
          //skip check stock api
          checkStockApi = {success:true}
        }
        
        // Hide the stock checking modal
        this.checkingStock = false;
        
        if (!checkStockApi.success) {
          this.$bvToast.toast(`Item is out of stock`, {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          return;
        }
      } catch (error) {
        // Hide the stock checking modal
        this.checkingStock = false;
        
        console.log(error);
        var errorObject = error.response.data.error;
        this.stockErrorArray = Object.entries(errorObject).map(([itemModel, message]) => ({
          itemModel,
          message
        }));
        
        // Show the stock error modal instead of a simple toast
        this.showStockErrorModal = true;
        
        this.$bvToast.toast(`Error checking stock - see details in the modal`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }
      
      
      this.disableButton = true;

      if (this.getDealer && this.getDealer != "") {
        //if user is dealer
        this.form.dealer = this.getDealer;
      } else {
        //if user is not dealer
        this.form.dealer = this.dealerChoice;
      }



      if (!this.getCounterID && (!this.form.dealer || this.form.dealer === "")) {
        this.$bvToast.toast(`Please Select Dealer First`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        // Prevent Any Saving Data From Run
        return;
      }

      for (const [index,value] of this.form.items.entries()) {
        // validation for make sure there is at least 1 item in items list
      for (const [index,value] of this.form.items.entries()) {
        if(!value.model||value.model=="" ) {
          this.$bvToast.toast(`Please select item model on Item number `+(index+1), {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          this.disableButton = false;
          return; 
        } 
        
        if(!value.qty||value.qty==0 ) {
          this.$bvToast.toast(`Item quantity cannot empty on Item number `+(index+1), {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          this.disableButton = false;
          return;
        } 
      }  
      }

      if(this.form.customer.firstName == "" ){
        this.$bvToast.toast(`Please Add Name`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        // Prevent Any Saving Data From Run
        return;
      }

      //save total
      this.form.subTotal = this.cartTotal;
      this.form.tax = this.gstTotal;
      this.form.totalPrice = this.cartTotalPrice;
      this.form.totalDiscount = this.cartTotalDiscount;
      this.form.highestDiscount = this.highestDiscount;
      //end save total

      //this industryType
      this.form.distChan = this.selectedIndustryType
      this.form.fromType = "rsp"
      if (this.$route.query.counterID) {
        this.form.counterID = this.$route.query.counterID
      }

      // Set order status based on discount
      if (this.getCounterID && this.highestDiscount > this.generalDiscountValue) {
        this.form.orderStatus = "Awaiting Discount Approval"
      } else {
        this.form.orderStatus = "Checking"
        
        // Mark all items as active
        this.form.items = this.form.items.map(el => {
          return {
            ...el,
            status: "",
          }
        })
      }


      if(this.form.dealer){
        this.form.distributionChannel=  (this.form.dealer.industryType && this.form.dealer.industryType!="")?this.form.dealer.industryType:"SP"
      }
      if (this.getCounterID){
        this.form.distributionChannel = "SP"
      }

      

      let mFormCopy = JSON.parse(JSON.stringify(this.form));
      

      if (mFormCopy.items.length <= 0) {
        this.$bvToast.toast("Please Add Item First", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        return;
      }
      
      this.addKioskPo(mFormCopy)
        .then(async (response) => {
          var poID = response.data.data._id
          this.disableButton = false;
          sessionStorage.setItem("toastMessage", "Add Kiosk Purchase Order Successfully");
          sessionStorage.removeItem('previousRouteName');
          if (this.$route.query.counterID || this.goTo == 'counter') {
            //add kiosk for counter

          this.$router.push({ name: 'kiosk-po-detail', params: { id: poID } });
          }
          else{
            this.$router.push({ name: 'kiosk-po' });
          }
        })
        .catch(async (e) => {
          this.disableButton = false;
          console.log(e);
          this.$bvToast.toast("Create Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "error",
              solid: true,
            });
          await sleep(2000);
          // this.$router.push({ name: "order" });
        });
    },
    fillItemInfoForm(index, selectedData, cartItem) {
      this.selectedImage = selectedData.item.image;
       if (!this.selectedImage) {
        this.disableButtonImage = true;
       }else{
        this.disableButtonImage = false;
       }
      var quantityTemp = !cartItem
        ? 1 //if cartItem undefined, quantity is 1
        : !cartItem.qty
        ? 1 //if cartItem.quantity undefined, quantity is 1
        : typeof cartItem.qty == "string"
        ? parseInt(cartItem.qty)
        : cartItem.qty;
      let data = Object.assign(cartItem, {
        description: selectedData.item.description,
        price: selectedData.price,
        qty: quantityTemp,
        totalPrice: (selectedData.price - (selectedData.price * (cartItem.unitDiscount ? (cartItem.unitDiscount / 100) : 0))) * quantityTemp,
        itemModel: selectedData.item.itemModel,
        model: selectedData.item.itemModel,
        id: selectedData.item._id,
        channel: selectedData.channel,
        unitDiscount: cartItem.unitDiscount || 0,
        discountAmount: quantityTemp * (selectedData.price*(cartItem.unitDiscount ? (cartItem.unitDiscount / 100) : 0)),
        availableQty: quantityTemp, // Set to actual quantity
      });

      this.form.items.splice(index, 1, data);
      this.computeItems();
    },
    changeItemInfoQty(index, cartItem) {
      //ini otomatis perhitungan waktu qty per item diubah
      this.updateItemCalculations(index, cartItem, false, true); // Pass quantityChanged flag
    },
    changeItemInfoDiscount(index, cartItem) {
      // Only apply discount if getCounterID is true
      if (!this.getCounterID) return;
      
      this.flagInputPrice = true;
      this.updateItemCalculations(index, cartItem, true, false); // unitDiscountChanged = true, quantityChanged = false
      
      // Update highest discount if needed
      if (parseFloat(cartItem.unitDiscount) > this.highestDiscount) {
        this.highestDiscount = parseFloat(cartItem.unitDiscount);
      }
    },
    computeItems() {
      // Only apply discounts if getCounterID is true
      if (!this.getCounterID) {
        // For non-counter mode, ensure all items have 0 discount
        this.computedItemsResult = this.form.items.map((item, index) => {
          // Reset any discount that might have been set
          item.unitDiscount = 0;
          
          // Update total price without discount
          item.totalPrice = item.price * item.qty;
          
          return {
            ...item,
            unitDiscount: 0,
            discountAmount: 0,
            parentIndex: index,
            availableQty: item.qty || 1
          };
        });
        
        this.highestDiscount = 0;
        return;
      }
      
      // Process all items and update computed values
      this.computedItemsResult = this.form.items.map((item, index) => {
        // If unit discount is not set, initialize it
        if (item.unitDiscount === undefined) {
          item.unitDiscount = 0;
          item.discountAmount = 0;
        }
        
        // Cap discount at maximum value
        if (parseFloat(item.unitDiscount) > this.maxDiscountValue) {
          item.unitDiscount = this.maxDiscountValue;
        }
        
        // Preserve manually entered discount amounts
        // If discountAmount exists and is valid, use it directly
        const existingDiscountAmount = this.parseToNumber(item.discountAmount) || 0;
        
        // Only recalculate discount amount if it's not manually set
        let finalDiscountAmount = existingDiscountAmount;
        if (existingDiscountAmount === 0 && item.unitDiscount > 0) {
          // Calculate discount amount from unit discount percentage only if no manual amount exists
          finalDiscountAmount = (item.price * (parseFloat(item.unitDiscount) / 100)) * item.qty;
        }
        
        // Calculate total price: (price * qty) - discountAmount
        const totalPriceBeforeDiscount = item.price * item.qty;
        const totalPrice = totalPriceBeforeDiscount - finalDiscountAmount;
        
        // Create a processed item with all necessary fields
        return {
          ...item,
          unitDiscount: parseFloat(item.unitDiscount) || 0,
          discountAmount: this.formatter(finalDiscountAmount),
          totalPrice: this.formatter(totalPrice),
          parentIndex: index,
          availableQty: item.qty || 1
        };
      });
      
      // Update highest discount
      this.highestDiscount = Math.max(
        ...this.computedItemsResult.map(item => parseFloat(item.unitDiscount || 0)),
        0 // Ensure we have at least 0 if array is empty
      );
    },
    cartRemoveItem(index) {
      //ini buat hapus 1 baris item list detail
      
      // Clean up editing state before removing item
      const cartItem = this.form.items[index];
      if (cartItem) {
        this.cleanupItemEditingState(index, cartItem);
      }
      
      this.form.items.splice(index, 1);
      this.computeItems(); // Recompute after removing
    },
    async openImageModal(item){
       this.modalImage = true
    },
    cartAddItem() {
      //ini buat tambah 1 baris item list detail
      this.form.items.push({ 
        itemModel: "", 
        description: "", 
        qty: 1, 
        price: 0, 
        totalPrice: 0, 
        unitDiscount: 0, 
        discountAmount: 0,
        availableQty: 1  // This is correct since qty is 1
      });
    },
    cartAddBundle() {
      
      //ini waktu setelah keluar popup untuk pilih bundle list item, akan ada button confirm. dan dimasukkan ke list item detail pesanan
      let { items, channel } = this.selectedBundle;
      var multiplier =(typeof this.bundleQuantity !="number")?parseInt(this.bundleQuantity):this.bundleQuantity

      if(multiplier<=0  || typeof multiplier !="number"){
        this.$bvToast.toast(`Please Enter Valid value for Bundle Quantity`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }

      //temporary save all selected item bundle list
      let tempItems = [];
      for (let i of items) {
        tempItems.push({
          qty: i.quantity*multiplier,
          price: parseFloat(i.price.$numberDecimal),
          totalPrice: parseFloat(i.price.$numberDecimal) * 1,
          label: `${i.itemModel} - ${i.id.description}`,
          description: i.id.description,
          itemModel: i.itemModel,
          model: i.itemModel,
          channel: channel._id,
          id: i.id._id,
        });
      }

      //replace if any empty index
      var checkInside = this.form.items.map((b) => {
        return Object.keys(b).length;
      });
      for (let a = 0; a < checkInside.length; a++) {
        if (checkInside[a] === 0) {
          this.form.items.splice(a, 1);
        }
      }

      //loop by temporary item bundle list to replace form po item list.
      for (let b of tempItems) {
        let searchIndex = this.form.items.findIndex((item) => {
          return item.id === b.id;
        });
        if (searchIndex < 0) {
          this.form.items.push({
            qty: b.qty,
            price: b.price,
            totalPrice: b.price * b.qty,
            label: `${b.itemModel} - ${b.description}`,
            description: b.description,
            itemModel: b.itemModel,
            model: b.itemModel,
            channel: channel._id,
            id: b.id,
          });
        } else {
          let qtyTemp= (typeof this.form.items[searchIndex].qty == "string")?
          parseInt(this.form.items[searchIndex].qty):this.form.items[searchIndex].qty
            this.form.items[searchIndex].qty = qtyTemp + b.qty;
          this.form.items[searchIndex].totalPrice =
            this.form.items[searchIndex].price *
            this.form.items[searchIndex].qty;
        }
      }
      console.log("this.form.items", this.form.items);

      this.selectedBundle = null;
      this.bundleQuantity = 1;
      this.showBundleModal = false;
    },
    datePicked(date) {
      //ini logic buat datepicker
      // Rule 1: Delivery Or Collect Date For Today Is Disable
      // Rule 2: Delivery Can Only Happen Next Day Or The Day After
      // Rule 3: Time Slot Option Is Tied To Time When Order Created
      // Rule 4: Time Order Created After Afternoon (18:00-00:00) Timeslot Available Is Next Day Morning
      // Rule 5: Time Order Created At Morning (00:00 - 12:00) Timeslot Available Is Afternoon Slot Next Day
      // Rule 6: Saturday (Half Day ?) And Sunday Is Off Day (No Delivery Happen Here)
      // Rule 7: If Today Is Friday And Choose Delivery Date At Saturday Only Morning Slot Available

      //new rule - July 2024
      /**
       *  1. Self Collect can be processed at the same timeslot (ie. If order in Monday Morning, then self collection can also be done in Monday Morning)
          2. If order is done after 5 PM, then self collect can be done by the next morning
          3. Delivery can be processed as soon as two days after order time (ie. If order in Monday Morning, then delivery can be done as soon as Wednesday Morning)
          a. by the same rule, If customer want to order and to have the items be delivered before the week ends (Sunday), then customer have to order before Thursday Afternoon
       */

      //resetting timeslot
      this.form.timeslot="";

      let selectedTime = moment(date);
      let selectedDay = selectedTime.days();
      let selectedDate = selectedTime.date();

      let now = moment();
      let currentHour = now.format("HH");
      let currentDay = now.days();
      let currentDate = now.date();
      let isDelivery = (this.form.orderType=='DELIVERY')

      let epoch = moment('1970-01-01')
      let nowToEpoch = now.diff(epoch,'days')
      let selectedToEpoch = selectedTime.diff(epoch,'days')

      if(isDelivery){
        //for delivery
        
        console.info('selectedDate('+selectedDate+')-currentDate('+currentDate+')',selectedDate-currentDate)

        //if selected is saturday
        if(selectedDay==6){
          this.timeslotOptions=[this.timeslotTemplate[0]]
          return;
        }

        if((selectedToEpoch-nowToEpoch==2)&& currentHour>=12){
          this.timeslotOptions=[this.timeslotTemplate[1],this.timeslotTemplate[2]]
          console.info('timeslotOption delivery 12 ',this.timeslotOptions)
          return;
        }
        //
        //return all
        this.timeslotOptions=this.timeslotTemplate
        console.info('timeslotOption delivery ',this.timeslotOptions)
        return;
      }else{
        //self collect
        
        //if selected is saturday
        if(selectedDay==6){
          this.timeslotOptions=[this.timeslotTemplate[0]]
          return;
        }

        if(selectedDay==currentDay && currentHour>=12){
          this.timeslotOptions=[this.timeslotTemplate[1]]
          console.info('timeslotOption self collect 12 ',this.timeslotOptions)
          return;
        }
        //return all
        this.timeslotOptions= [this.timeslotTemplate[0],this.timeslotTemplate[1]]
        console.info('timeslotOption self collect ',this.timeslotOptions)
        return;
      }


    },
    onItemSearch(search, loading) {
      loading(true);
      this.ajaxSearch(search, loading);
    },
    ajaxSearch: lodash.debounce(function(search, loading) {
      loading(true);
      var currentDealer;
      if (this.getDealer && this.getDealer != "") {
        //if user is dealer
        currentDealer = this.getDealer;
      } else {
        //if user is not dealer
        currentDealer = this.dealerChoice;
      }
      var industryType = this.selectedIndustryType
      this.getDealerKioskItemToOrder({
        industryType: industryType,
        item: search,
        entry:25,
        page:1,
      })
      .then((data) => {
        this.searchItems = 
        data
        .filter((distItem) => {
          const productHierarchy = distItem.item.productHierarchy;
          return (
            productHierarchy.startsWith("Z1000") ||
            productHierarchy.startsWith("A5100") ||
            productHierarchy.startsWith("U5100") ||
            productHierarchy.startsWith("U5300")
          );
        })
        .map((item) => {
          //handling item catalog only show at list when status = "" (Active)
          if (item.item.status === "") {
            item.price = parseFloat(item.price.$numberDecimal);
            return {
              label: `${item.item.itemModel} - ${item.item.description}`,
              description: item.item.description,
              itemModel: item.item.itemModel,
              ...item,
            };
          }
        });
        loading(false);
      })
      .catch((e) => {
        loading(false);
        console.log(e);
      });
    }, 500),
    ajaxItemSelected(item) {
      this.ajaxItem = item;
    },
    // validateInput(event) {
    //   const value = event.target.value;
    //   // Allow all alphanumeric & special case, except -
    //   const regex = /[*]/;
    //   if (regex.test(value)) {
    //     this.$bvToast.toast(`Inserting '*' in Customer PO is not allowed. Please use '/' instead`, {
    //       title: "Failed",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     this.form.customerPO = value.replace('*', '');
    //   }
    // },
    goBack(){
      if (this.$route.query.counterID) {
        this.$router.push({ name: 'kiosk-po-counter' });
      }
      else{
        this.$router.back()
      }
    },
    emptyDealer() {
      this.mandatoryStatus = true;
      this.form.deliveryType = "SOEC";
      this.dealerChoice = null;
      this.form.items = [{ itemModel: "", description: "", qty: 1, price: 0, totalPrice: 0, discountAmount: 0, unitDiscount: 0, availableQty: 1 }];
      this.form.customer.address = "";
      this.form.customer.email = "";
      this.form.customer.postal = "";
      this.form.customer.phone = "";
      this.form.customer.firstName = "";
      this.form.customer.street = "";
      this.form.customer.block = "";
      this.form.customer.buildingName = "";
      this.selectedIndustryType = "SP"; // Reset selected industry type
      this.searchItems = []; // Clear search items
      this.industryTypeValid = false; // Reset industry type validity
    },
    getDiscountAmountDisplay(cartItem, index) {
      const key = this.getItemKey(index, cartItem);
      const editState = this.editingStates.discountAmounts[key];
      
      if (editState && editState.editing) {
        return editState.tempValue !== undefined ? editState.tempValue : this.parseToNumber(cartItem.discountAmount);
      }
      return this.formatter(cartItem.discountAmount);
    },
    onDiscountAmountInput(index, cartItem, event) {
      const key = this.getItemKey(index, cartItem);
      const editState = this.editingStates.discountAmounts[key];
      
      // Get the value from the event
      const value = event.target ? event.target.value : event;
      
      if (editState && editState.editing) {
        editState.tempValue = value;
      } else {
        cartItem.discountAmount = value;
        this.updateItemCalculations(index, cartItem);
      }
    },
    startEditingDiscountAmount(index, cartItem) {
      const key = this.getItemKey(index, cartItem);
      // Use Vue.set for the editingStates object, not the item
      this.$set(this.editingStates.discountAmounts, key, {
        editing: true,
        tempValue: this.parseToNumber(cartItem.discountAmount)
      });
    },
    finishEditingDiscountAmount(index, cartItem) {
      const key = this.getItemKey(index, cartItem);
      const editState = this.editingStates.discountAmounts[key];
      
      if (editState && editState.editing) {
        const inputValue = this.parseToNumber(editState.tempValue);
        
        // Validate against maximum allowed discount amount
        const quantity = cartItem.qty || 0;
        const price = this.parseToNumber(cartItem.price);
        const maxAllowedDiscountAmount = (price * quantity * this.maxDiscountValue) / 100;
        
        let finalDiscountAmount = inputValue;
        let finalUnitDiscount = 0;
        
        if (price > 0 && quantity > 0) {
          // Calculate unit discount percentage for validation and display
          finalUnitDiscount = (inputValue / (price * quantity)) * 100;
          
          // Check if calculated discount exceeds maximum allowed
          if (finalUnitDiscount > this.maxDiscountValue) {
            finalDiscountAmount = maxAllowedDiscountAmount;
            finalUnitDiscount = this.maxDiscountValue;
            
            this.$bvToast.toast(`Discount amount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
              title: "Discount Limited",
              variant: "warning",
              solid: true,
            });
          }
        }
        
        // Update the item with validated values
        // Preserve the exact discount amount entered by the user
        cartItem.discountAmount = this.formatter(finalDiscountAmount);
        // Store unit discount with high precision to avoid recalculation issues
        cartItem.unitDiscount = finalUnitDiscount;
        
        // Calculate total price directly from discount amount to avoid rounding errors
        const totalPriceBeforeDiscount = price * quantity;
        cartItem.totalPrice = this.formatter(totalPriceBeforeDiscount - finalDiscountAmount);
        
        // Clean up editing state
        this.$delete(this.editingStates.discountAmounts, key);
        
        // Update highest discount if needed (use the actual unit discount for comparison)
        if (finalUnitDiscount > this.highestDiscount) {
          this.highestDiscount = finalUnitDiscount;
        }
        
        // Trigger overall computation without changing this item's values
        this.computeItems();
      }
    },
    // Parse value to clean number for calculations
    parseToNumber(value) {
      try {
        if (typeof value === 'object' && value.$numberDecimal) {
          return parseFloat(value.$numberDecimal);
        }
        const parsed = parseFloat(value) || 0;
        if (isNaN(parsed)) {
          console.warn('Invalid number parsed:', value);
          return 0;
        }
        return parsed;
      } catch (error) {
        console.error('Error parsing number:', error);
        return 0;
      }
    },
    // Get unique key for item to track editing state
    getItemKey(index, cartItem) {
      return `${index}_${cartItem.id || cartItem.itemModel || index}`;
    },
    // Clean up editing state for a specific item
    cleanupItemEditingState(index, cartItem) {
      const key = this.getItemKey(index, cartItem);
      if (this.editingStates.discountAmounts[key]) {
        this.$delete(this.editingStates.discountAmounts, key);
      }
    },
    updateItemCalculations(index, cartItem, unitDiscountChanged = false, quantityChanged = false) {
      // Only apply discount calculations if getCounterID is true
      if (!this.getCounterID && !quantityChanged) return;
      
      // Directly update the input field value to enforce the maximum
      if (parseFloat(cartItem.unitDiscount) > this.maxDiscountValue) {
        cartItem.unitDiscount = this.maxDiscountValue;
        this.$bvToast.toast(`Discount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
            title: "Discount Limited",
            variant: "warning",
            solid: true,
          });
      }

      // Ensure discount doesn't exceed maximum
      const unitDiscount = parseFloat(cartItem.unitDiscount || 0) <= this.maxDiscountValue 
        ? parseFloat(cartItem.unitDiscount || 0) 
        : this.maxDiscountValue;
      
      const quantity = cartItem.qty || 0;
      const price = this.parseToNumber(cartItem.price);
      
      // Handle discount calculation based on what changed
      let finalDiscountAmount = 0;
      let finalUnitDiscount = unitDiscount;
      
      if (unitDiscountChanged) {
        // If unit discount changed, recalculate discount amount
        finalDiscountAmount = (price * (unitDiscount / 100)) * quantity;
        finalUnitDiscount = unitDiscount;
      } else if (quantityChanged) {
        // If quantity changed, preserve the discount percentage and recalculate discount amount
        finalUnitDiscount = unitDiscount; // Keep existing percentage
        finalDiscountAmount = (price * (finalUnitDiscount / 100)) * quantity;
      } else {
        // If neither changed, preserve existing discount amount
        finalDiscountAmount = this.parseToNumber(cartItem.discountAmount) || 0;
        // Recalculate unit discount percentage based on preserved discount amount
        const totalPriceBeforeDiscount = price * quantity;
        if (totalPriceBeforeDiscount > 0 && finalDiscountAmount > 0) {
          finalUnitDiscount = (finalDiscountAmount / totalPriceBeforeDiscount) * 100;
        }
      }
      
      // Calculate total price: (price * quantity) - discountAmount
      const totalPriceBeforeDiscount = price * quantity;
      const totalPrice = totalPriceBeforeDiscount - finalDiscountAmount;
      
      let updatedCartItem = {
        ...cartItem,
        unitDiscount: finalUnitDiscount,
        discountAmount: this.formatter(finalDiscountAmount),
        totalPrice: this.formatter(totalPrice),
        availableQty: cartItem.qty || 1
      };
      
      this.form.items.splice(index, 1, updatedCartItem);
      this.computeItems();
    },
  },
  beforeDestroy() {
    // Clean up any remaining editing states to prevent memory leaks
    this.editingStates = {
      discountAmounts: {},
      discountAmountsReplacement: {}
    };
  },
  computed: {
    ...mapGetters({
      itemsOptions: "item/itemsOptions",
      itemsBundles: "item/itemsBundles",
      currentGST: "GST/getCurrentGST",
      maxDiscount: "discount/getMaxDiscount",
      generalDiscount: "discount/getGeneralDiscount"
    }),
    maxDiscountValue() {
      return this.maxDiscount && this.maxDiscount.value ? this.maxDiscount.value : 100;
    },
    generalDiscountValue() {
      return this.generalDiscount && this.generalDiscount.value ? this.generalDiscount.value : 20;
    },
    user() {
      //buat cek informasi akun yang sedang login
      return this.$store.getters["auth/getActiveUser"];
    },
    dealer() {
      return this.$store.getters["dealer/getDealers"].filter(
        (x) => x.status === ""
      );
    },
    getDealer() {
      //ini buat cek apakah akun yang sedang login termasuk dealer atau bukan
      //kalau user bukan dealer, return undefined
      var tempDealer = this.$store.getters["dealer/getCurrentDealers"];

      // if (tempDealer === null) {
      //   tempDealer = this.dealerChoice;
      //   //this.defineDealer();
      // }
      return tempDealer;
    },
    getCounterID() {
      // Check if counterID is provided in the query parameters
      return this.$route.query.counterID ? true : false;
    },
    counterPaymentSelectOptions() {
      if (!this.getCounterID) {
        return this.paymentOption;
      }
      if (this.counterPayLaterAllowed) {
        return this.paymentOption;
      }
      return this.paymentOption.filter((o) => o.value !== "LTER");
    },
    cartTotalPrice: {
      //kalkulasi subtotal
      get() {
        return this.form.items.reduce((acc, current) => {
          if (current.totalPrice === undefined || current.totalPrice === null || current.totalPrice === "") {
            return acc;
          }

          return acc + this.parseToNumber(current.totalPrice);
        }, 0);
      },
      set(val) {
        return;
      },
    },
    cartTotalDiscount: {
      get() {
        let totalPriceBase = this.form.items.reduce((acc, current) => {
          return acc + (this.parseToNumber(current.price) * this.parseToNumber(current.qty));
        }, 0);

        if (totalPriceBase <= 0) {
          return 0;
        }

        return ((totalPriceBase - this.cartTotalPrice) / totalPriceBase) * 100;
      },
      set(val) {
        return;
      },
    },
    cartTotal() {
      //kalkulasi total price — always numeric to avoid string concat → NaN
      return this.parseToNumber(this.cartTotalPrice) + this.parseToNumber(this.gstTotal);
    },
    gstTotal() {
      //ini nanti akan ada update GST sesuai settings. CR
      let valuePercent = this.parseToNumber(this.currentGST && this.currentGST.value) / 100;
      let gstString = (
        Math.round(this.parseToNumber(this.cartTotalPrice) * valuePercent * 100) / 100
      ).toFixed(2);
      return Number(gstString);
    },
  },
};
</script>

<style>
.deliveryUnitNo {
  width: 100px;
}
.cart__area {
  display: flex;
  flex-direction: column;
}

.cart__area-body {
  display: grid;
  grid-template-rows: 100%;
  overflow-x: scroll;
  margin: 10px 0;
}

.cart__area-columns {
  display: grid;
  grid-template-columns: 30% auto 15% 15% 15% auto;
  column-gap: 15px;
  margin: 0 0 5px 0;
}

.cart__area-columns-with-discount {
  display: grid;
  grid-template-columns: 30% 10% 10% 10% 10% 10% auto;
  column-gap: 15px;
  margin: 0 0 5px 0;
}

.cart__area-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.cart__area-line-info {
  display: flex;
  align-items: center;
  margin: 0 0 5px 0;
}

.cart__area-line-info span {
  width: 100%;
  margin: 0 5px 0 0;
}

.cart__area-line-info input {
  width: 100px;
}

.cart-area-columns span {
  font-weight: bold;
}

.v-select .vs__dropdown-toggle {
  height: 2.714rem;
  padding: 0;
}

@media only screen and (max-width: 681px) {
  /* .halo {
    background-color: rebeccapurple;
    
  } */
  .cart__area-columns {
    display: none;
  }
}

@media only screen and (min-width: 682px) {
  /* .halo {
    background-color: red;
  } */
  .halo {
    background-color: red;
  }

  .cart__area-columns_mobile {
    display: none;
  }
}
</style>
